export enum EcErrorCode {
  NOT_FOUND = 40009,
  ZIPCODE_FAILURE = 40011,
  SPECIAL_ZIPCODE_FAILURE = 40016,
}
